import CFG from "@bd-core/config";
import axios from "axios";

const bdapi = axios.create({
    baseURL: CFG.restURL,
});

// Uncomment code below and if your application using token
// bdapi.defaults.headers.common['Authorization'] = AUTH_TOKEN;
export default bdapi;
